import type { Decorator } from 'final-form';

import { decorateSubmit } from './utils';

export const scrollToFirst: Decorator<Record<string, unknown>> = decorateSubmit(form => {
    const state = form.getState();
    const fields = form.getRegisteredFields();
    const { errors } = state;
    const nextElement = fields.find(elementName => errors[elementName]);

    if (!nextElement) return;
    const current = form.getFieldState(nextElement)?.data?.ref?.current;
    if (!current) return;

    const { scrollTop } = document.documentElement;
    const top = current.getBoundingClientRect().top + scrollTop;
    if (top < scrollTop) window.scrollTo({ top });
});
